import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";
import { ONBOARDING_STEPS } from "./OnboardingShell";

/** Final onboarding step. Marks setup complete so the wizard isn't shown again. */
export function OnboardingDonePage() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("addy.onboarded", "true");
  }, []);

  return (
    <div className="max-w-2xl font-sans">
      <div className="space-y-2">
        <Badge variant="secondary">Thiết lập ban đầu</Badge>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          Thiết lập hoàn tất 🎉
        </h1>
        <p className="text-muted-foreground">
          Phòng khám đã sẵn sàng đón bệnh nhân.
        </p>
      </div>

      <div className="my-4 flex flex-wrap gap-1.5">
        {ONBOARDING_STEPS.map((s) => (
          <span
            key={s.path}
            className="h-1.5 min-w-6 flex-1 rounded-sm bg-primary"
          />
        ))}
      </div>

      <Card>
        <CardContent className="grid gap-4 p-5">
          <div className="flex items-start gap-3 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2.5 text-sm text-emerald-800">
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
            <span>
              Bạn có thể chỉnh sửa mọi thiết lập bất cứ lúc nào trong mục Cài đặt.
            </span>
          </div>
          <Button
            type="button"
            className="w-full"
            onClick={() => navigate("/dashboard")}
          >
            Vào Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
